import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, shareReplay, tap } from 'rxjs';
import { AbstractCacheService } from '../service/abstract-cache.service';
import { LoggerService } from '../service/logger.service';
import { CACHE_IT } from '../const/tokens.constants';

@Injectable({
  providedIn: 'root',
})
export class HttpCacheService extends AbstractCacheService<HttpResponse<unknown>> {}

function isCacheable(req: HttpRequest<any>): boolean {
  return req.method === 'GET' && req.context.get(CACHE_IT);
}

@Injectable()
export class CacheHttpInterceptor implements HttpInterceptor {
  constructor(
    private cache: HttpCacheService,
    private logger: LoggerService
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const requestUrl = req.url;

    if (!isCacheable(req)) {
      return next.handle(req);
    }

    const cachedHttpResponse$ = this.cache.getValue(requestUrl);

    if (cachedHttpResponse$) {
      this.logger.log(['Cached response: ', requestUrl]);

      return cachedHttpResponse$ as Observable<HttpEvent<unknown>>;
    } else {
      const newRequest$ = next.handle(req).pipe(
        tap((event: HttpEvent<unknown>): void => {
          // Check if the event is an HttpResponse (meaning the response has arrived).
          if (event instanceof HttpResponse) {
            this.cache.setValue(of(event as HttpResponse<unknown>), requestUrl);
          }
        }),

        shareReplay(1)
      );
      return newRequest$;
    }
  }
}
